import apiClient from './client'
import type {
  LoginRequest,
  TeacherRegisterRequest,
  TokenResponse,
  User,
  UserUpdate,
  UserPromoteRequest,
  ChangePasswordRequest,
  CreateSupervisorRequest,
  CreateSupervisorResponse,
  ResetPasswordResponse,
} from '@/types/api'

export const authApi = {
  login(data: LoginRequest) {
    return apiClient.post<TokenResponse>('/auth/login', data)
  },

  refresh(refreshToken: string) {
    return apiClient.post<TokenResponse>('/auth/refresh', { refresh_token: refreshToken })
  },

  register(data: TeacherRegisterRequest) {
    return apiClient.post<{ message: string; user_id: number }>('/auth/register', data)
  },

  me() {
    return apiClient.get<User>('/users/me')
  },

  listUsers(role?: string, isActive?: boolean | null) {
    return apiClient.get<User[]>('/users', {
      params: {
        ...(role ? { role } : {}),
        ...(isActive === undefined || isActive === null ? {} : { is_active: isActive }),
      },
    })
  },

  updateUser(id: number, data: UserUpdate) {
    return apiClient.patch<User>(`/users/${id}`, data)
  },

  promoteUser(id: number, data: UserPromoteRequest) {
    return apiClient.post<User>(`/users/${id}/promote`, data)
  },

  resetPassword(id: number) {
    return apiClient.post<ResetPasswordResponse>(`/users/${id}/reset-password`)
  },

  changePassword(data: ChangePasswordRequest) {
    return apiClient.post<User>('/auth/change-password', data)
  },

  createSupervisor(data: CreateSupervisorRequest) {
    return apiClient.post<CreateSupervisorResponse>('/admin/create-supervisor', data)
  },
}
